import { mapstoreMenuClose } from './_mapstore-menu'

const containerPanzoom = document.querySelector('.js-mapstorePanzoom')
const mapstoreSvgContainer = $('.js-mapstoreSvgContainer')
const mapstoreStage = $('.js-mapstoreStage')

let currentShopId = null

if (containerPanzoom) {
	const panzoom = Panzoom(containerPanzoom, {
		minScale: 1,
		maxScale: 4,
	})

	$('.js-mapstorePanzoomPlus').on('click',  panzoom.zoomIn)
	$('.js-mapstorePanzoomMinus').on('click', panzoom.zoomOut)
}

$(document).on('click', '.js-mapstoreShopControl', (e) => {
	const shopId = $(e.currentTarget).data('shop-id')
	const floorNumber = $(e.currentTarget).data('floor')

	currentShopId = shopId

	mapstoreShopsClose();
	mapstoreMenuClose();
	selectCurrentShop();

	if (floorNumber) {
		$(`.js-mapstoreFloorButton[data-floor-number="${floorNumber}"]`).trigger('click')
	}
})


$('.js-mapstoreShopClose').on('click', (e) => {
	$('[data-shop-id]').removeClass('is_active')

	currentShopId = null
})

$('.js-mapstoreNavButton').on('click', (e) => {
	const name = $(e.currentTarget).data('name')

	$(e.currentTarget).toggleClass('is_active')

	visibleMapNavigation()
})

$('.js-mapstoreFloorButton').on('click', (e) => {
	const levelUrl = $(e.currentTarget).data('level-url')

	mapstoreShopsClose()

	$.ajax({
		url: levelUrl,
		processData: false,
		contentType: false,
		method: 'GET',
		success: function(response) {
			mapstoreStage.html(response)
			selectCurrentShop()
		}
	})

	$(e.currentTarget)
		.addClass('is_active')
		.siblings()
		.removeClass('is_active')
})

function visibleMapNavigation () {
	const selected = []

	$('.js-mapstoreNavButton.is_active').each((i, el) => {
		selected.push($(el).data('name'))
	})

	resetMapNavigation()

	if (selected.length > 0) {
		mapstoreSvgContainer.addClass('hasNaviFilter')
	}

	$.each(selected, (i, el) => {
		mapstoreSvgContainer.addClass(`visibleNavi${el}`)
	})
}

function resetMapNavigation () {
	mapstoreSvgContainer.removeClass(`
		hasNaviFilter 
		visibleNaviWC 
		visibleNaviElevator 
		visibleNaviEscalator 
		visibleNaviStairs 
		visibleNaviATM 
		visibleNaviDisabled 
		visibleNaviMotherRoom
	`)
}

function mapstoreShopsClose () {
	$(`[data-shop-id]`).each((i, el) => {
		$(el)[0].classList.remove('is_active')
	})
}

function selectCurrentShop () {
	if (currentShopId) {
		$(`[data-shop-id="${currentShopId}"]`).each((i, el) => {
			$(el)[0].classList.add('is_active')
		})
	}
}

export { mapstoreShopsClose }